const MONTHS = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];

// Em UTC, igual ao `/api/og`: com hora local, um post publicado perto da
// virada do mês mostraria um mês na listagem e outro no preview do link.
const formatPeriod = (iso: string | null): string => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return `${MONTHS[date.getUTCMonth()]}/${date.getUTCFullYear()}`;
};

interface PostCoverCardProps {
  publishedAt: string | null;
}

/**
 * Capa gerada do post — substitui a imagem de capa. Mostra o mês/ano de
 * publicação e a marca sobre um leve véu da cor da marca. É decorativa: todo o
 * conteúdo textual (categoria, título, autor) vem abaixo dela no `PostCard`,
 * então o card fica escondido de leitores de tela.
 *
 * O fundo é `ds-brand-50` com uma faixa de acento `ds-brand-500` à esquerda —
 * não um gradiente radial, que é vocabulário de template (§ 2 do DESIGN.md) e
 * que aqui só existia porque não havia token para o tom claro da marca.
 * Contraste do mês (`ds-ink-800` sobre `ds-brand-50` #FFF5EE): 11,46:1.
 */
export const PostCoverCard = ({ publishedAt }: PostCoverCardProps) => {
  const period = formatPeriod(publishedAt);

  return (
    <div
      aria-hidden="true"
      className="bg-ds-brand-50 border-ds-brand-500 rounded-ds-md @container relative aspect-[16/5] overflow-hidden border-l-4"
    >
      <div className="relative flex items-start justify-between gap-4 p-5 @2xs:p-6">
        {period && (
          <span className="font-ds-sans text-ds-small text-ds-ink-800 shrink-0 font-semibold first-letter:uppercase">
            {period}
          </span>
        )}
        {/* A capa decide pela PRÓPRIA largura (container query), não pela da
            tela: em "Continue lendo" os três cards dividem a coluna ao lado do
            índice e a capa fica com ~200px — a logo completa não cabia e o
            `overflow-hidden` a cortava ("fidex"). Abaixo de 18rem vai só o
            ícone da marca. */}
        <img
          src="/landing-page/logo-fidexa.svg"
          alt=""
          width={80}
          height={20}
          className="ml-auto hidden h-5 w-auto @2xs:block"
        />
        <img
          src="/landing-page/logo-icon-fidexa.svg"
          alt=""
          width={20}
          height={20}
          className="ml-auto size-5 @2xs:hidden"
        />
      </div>
    </div>
  );
};
